import Picture1 from '../images/1.svg'
import Picture2 from '../images/2.svg'
import Picture3 from '../images/3.svg'
import Picture4 from '../images/4.svg'
import Picture5 from '../images/5.svg'
import Picture6 from '../images/6.svg'
import Picture7 from '../images/7.svg'
import Picture8 from '../images/8.svg'
import Picture9 from '../images/9.svg'
import Picture10 from '../images/10.svg'
import Picture11 from '../images/11.svg'
import Picture12 from '../images/12.svg'
import Picture13 from '../images/13.svg'
import Picture14 from '../images/14.svg'
import Picture15 from '../images/15.svg'
import Picture16 from '../images/16.svg'
import Picture17 from '../images/17.svg'
import Picture18 from '../images/18.svg'
import Picture19 from '../images/19.svg'
import Picture20 from '../images/20.svg'




const ImageRandom = () => {
    var ImageArr =[Picture1,Picture2,Picture3,Picture4,Picture5,Picture6,Picture7,Picture8,Picture9,Picture10,Picture11,Picture12,Picture13
        ,Picture14,Picture15,Picture16,Picture17,Picture18,Picture19,Picture20]
    var index = Math.floor(Math.random() * ImageArr.length);
    
    return (
        (ImageArr[index])

    )
 }
     
 export default ImageRandom
 